// src/pages/home.tsx
import React, { useState } from "react";
import { Button } from "@blueprintjs/core";
import { ContactForm } from "../components/ContactForm";
// import { useNavigate } from "react-router-dom";

console.log("Home.tsx loaded");

export default function Home() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  // const navigate = useNavigate();
  // Prevent homepage from rendering during OAuth redirect callback
  if (new URLSearchParams(window.location.search).get("code")) return null;

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {/* ─── Simple Header with Auth Buttons ───────────── */}
      <div
        style={{
          width: "100vw",
          position: "relative",
          left: "50%",
          right: "50%",
          marginLeft: "-50vw",
          marginRight: "-50vw",
          background: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
          padding: "1rem 2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          zIndex: 1100,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <a
            href="https://www.ee-aero.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", alignItems: "center", textDecoration: "none" }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/ee-design/images/ee-01.png`}
              alt="Endeavor Elements Logo"
              style={{ width: "48px", verticalAlign: "middle", marginRight: 12 }}
            />
            <span style={{ fontWeight: 600, fontSize: 22, color: "#222" }}>ConformIQ</span>
          </a>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* <Button
            text="Sign Up"
            intent="primary"
            style={{ marginRight: "1rem" }}
            disabled
            onClick={() => {
              console.log("[Home] Sign Up button clicked");
              navigate("/signup");
            }}
          /> */}
          {/* <Button
            text="Login"
            intent="primary"
            style={{ marginRight: "1rem" }}
            onClick={() => {
              console.log("[Home] Login button clicked");
              navigate('/login');
            }}
          /> */}
          {/* <Divider style={{ height: 32, alignSelf: "center", marginRight: "1rem" }} /> */}
          <Button
            text="Contact Us"
            intent="warning"
            onClick={() => setIsContactFormOpen(true)}
            style={{
              marginRight: "1rem",
              backgroundColor: "#FF4F00",
              borderColor: "#FF4F00",
              color: "#fff",
              fontWeight: 600,
              fontSize: 18,
              borderRadius: 8,
              padding: "1rem 2.5rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              textDecoration: "none",
              transition: "background 0.2s",
              border: "none",
              minWidth: 140,
            }}
          />
        </div>
      </div>

      {/* ─── ConformIQ Description Banner ─────────────── */}
      <div
        style={{
          width: "100vw",
          position: "relative",
          left: "50%",
          right: "50%",
          marginLeft: "-50vw",
          marginRight: "-50vw",
          background: "#f7f9fb",
          color: "#1a1a1a",
          borderBottom: "1px solid #e0e6ed",
          minHeight: "45vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: 0,
        }}
      >
        <div style={{ width: "100%", padding: "4rem 6vw 3rem 6vw" }}>
          <div style={{ fontWeight: 700, fontSize: 38, lineHeight: 1.15, marginBottom: 36, maxWidth: 900 }}>
            Data-Driven, AI-assisted Platform for Systems Engineering, Functional Safety, & Certification.
          </div>
          <a
            href="https://calendly.com/yves-remmler/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              background: "#FF4F00",
              color: "#fff",
              fontWeight: 600,
              fontSize: 18,
              border: "none",
              borderRadius: 8,
              padding: "1rem 2.5rem",
              textDecoration: "none",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              transition: "background 0.2s",
              marginTop: 8,
              marginBottom: 0,
            }}
          >
            Book a Demo
          </a>
        </div>
      </div>

      {/* ─── Main Content ──────────────────────────────── */}
      <main
        style={{
          flexGrow: 1,
          textAlign: "center",
          padding: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "2.5fr 1fr",
            width: "100vw",
            position: "static",
            left: undefined,
            right: undefined,
            marginLeft: 0,
            marginRight: 0,
            maxWidth: "none",
            borderTop: "1px solid #222",
            borderBottom: "1px solid #222",
            minHeight: 400,
          }}
        >
          {/* Left: Big Report Card */}
          <div style={{ padding: "3rem 4vw 3rem 4vw", display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <div style={{ fontWeight: 700, fontSize: 34, color: "#6CA6F7", marginBottom: 24, lineHeight: 1.15, textAlign: "left" }}>
              Find out how your Aircraft, System, or Subsystem can be certified:
            </div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 32, maxWidth: 900, marginLeft: 36 }}>
              <div style={{ fontSize: 16, color: "#222", textAlign: "left", maxWidth: 600 }}>
                Upload your aerospace project and receive a certification strategy within 24 hours, powered by ConformIQ’s AI engine. We review your documentation to generate a 2-page roadmap, with options to upgrade to a detailed 80+ page strategy or expert-reviewed report. Get a clear, professional assessment of your certification path.
              </div>
              <a
                href="mailto:support@endeavor-elements.com?subject=Request%20Certification%20Report"
                style={{
                  display: "inline-block",
                  background: "#FF4F00",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 18,
                  border: "none",
                  borderRadius: 8,
                  padding: "1rem 2.5rem",
                  textDecoration: "none",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  transition: "background 0.2s",
                  marginLeft: 32,
                  minWidth: 180,
                  textAlign: "center"
                }}
              >
                Get Report
              </a>
            </div>
          </div>
          {/* Right: Features Card */}
          <div style={{ borderLeft: "1px solid #222", padding: "3rem 2vw 3rem 2vw", display: "flex", flexDirection: "column", justifyContent: "flex-start", minWidth: 260 }}>
            <div style={{ fontWeight: 700, fontSize: 26, marginBottom: 18, textAlign: "left" }}>Features</div>
            <div style={{ textAlign: "left", fontSize: 16, marginBottom: 32 }}>&gt; CIQ for Initial Airworthiness</div>
            <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 12, textAlign: "left" }}>Coming Soon</div>
            <div style={{ textAlign: "left", fontSize: 16 }}>
              &gt; CIQ for Cont. Airworthiness<br />
              &gt; CIQ for UAS Waivers
            </div>
          </div>
        </div>
      </main>

      {/* ─── Footer ────────────────────────────────────── */}
      <footer
        style={{
          backgroundColor: "#f5f5f5",
          textAlign: "left",
          padding: "1rem 2rem 1rem 2rem",
          fontSize: "0.85rem",
          color: "#666",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>© {new Date().getFullYear()} Endeavor Elements, Inc. · All rights reserved.</span>
      </footer>
      
      {/* Contact Form Modal */}
      {isContactFormOpen && (
        <ContactForm onClose={() => setIsContactFormOpen(false)} />
      )}
    </div>
  );
}
